/** Blank wizard draft for new events — not demo/stride/therme seed data. */

export function isoToday() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function createEmptyEventWizardDraft() {
  return {
    title: "",
    slug: "",
    slugLocked: false,
    format: "In-person",
    subtitle: "",
    startDate: isoToday(),
    endDate: "",
    timezone: "Asia/Singapore",
    venue: "",
    capacity: 50,
    accent: "var(--primary)",
    secondaryAccent: "",
    cover: "",
    logoUrl: "",
    senderName: "",
    replyTo: "",
    registrationApproval: "auto_confirm",
    tickets: [],
    tracks: [],
    formFields: [
      { id: "f_name", type: "short_answer", label: "Full name", required: true },
      { id: "f_email", type: "email", label: "Work email", required: true },
      { id: "f_company", type: "short_answer", label: "Company", required: false },
    ],
  };
}

const DEMO_SLUGS = new Set(["stride-2026", "thermesggbreak", "ledger-summit"]);
const DEMO_TICKET_IDS = new Set(["t_early", "t_regular", "t_vip"]);

/** Detect persisted demo/template wizard state (e.g. from default tenant). */
export function isDemoEventWizardDraft(draft) {
  if (!draft || typeof draft !== "object") return false;
  const slug = String(draft.slug || "").trim().toLowerCase();
  if (DEMO_SLUGS.has(slug)) return true;
  const tickets = Array.isArray(draft.tickets) ? draft.tickets : [];
  if (tickets.some((t) => DEMO_TICKET_IDS.has(String(t?.id || "")))) return true;
  if (Number(draft.capacity) === 4200 && tickets.length >= 3) return true;
  return false;
}
